import { createAction } from 'redux-actions';
import { getProgram } from '@/services/program/getProgram';

export const setStoreProgram = createAction('SET_STORE_PROGRAM');

export const setProgramAction = createAction('SET_PROGRAM');

export const getProgramAction = (organizationId, programId, params = null) => {
    return (dispatch) => {
        getProgram(organizationId, programId, params)
        .then(program => {
            dispatch(setProgramAction(program))
        })
        .catch(e => {
            throw new Error(`API error:${e?.message}`);
        });
    };
};